import produce from 'immer';
import { ErrorActions, ErrorReducer, ErrorState } from '@common/Checkout/Shopcart/types';
import {
    SET_SHOPCART_ERROR,
    SET_VOUCHER_CODE_ERROR,
    REMOVE_VOUCHER_CODE_ERROR,
    SET_GIFTCARD_CODE_ERROR,
    REMOVE_GIFTCARD_CODE_ERROR,
} from '../actions/constants';

const initialState: ErrorState = {
    cart: null,
    voucher: null,
    giftCard: null,
};

const reducer: ErrorReducer = produce((state: ErrorState, action: ErrorActions) => {
    const { type, payload } = action;

    switch (type) {
        case SET_SHOPCART_ERROR: {
            state.cart = payload;
            break;
        }

        case SET_VOUCHER_CODE_ERROR: {
            state.voucher = payload;
            break;
        }

        case REMOVE_VOUCHER_CODE_ERROR: {
            state.voucher = null;
            break;
        }

        case SET_GIFTCARD_CODE_ERROR: {
            state.giftCard = payload;
            break;
        }

        case REMOVE_GIFTCARD_CODE_ERROR: {
            state.giftCard = null;
            break;
        }
        // skip default
    }
}, initialState);

export default reducer;
